/**
 * author       : zwl
 * createTime   : 2018/6/28 下午5:08
 * description  :
 */
import api from 'util/axios'

export function getTotalMsg () {
  return api({
    method: 'get',
    url: '/message'
  })
}

export function getMsgList (params) {
  return api({
    method: 'post',
    url: '/message/getMsgList',
    data: params
  })
}

export function isRead (mesId) {
  return api({
    method: 'post',
    url: '/message/isRead/' + mesId
  })
}

export function isDo (params) {
  return api({
    method: 'post',
    url: '/message/isDo',
    data: params
  })
}
